import { useContext } from 'react';

import { ActiveView } from '../components/AIAssistant/shared/constants';
import { aiAssistantContext } from '../state/AIAssistantContextProvider';

// True while a podcast's audio is still generating (the PODCAST_LOADING view).
const useIsPodcastGenerating = () => {
	const { activeView } = useContext(aiAssistantContext);
	return activeView === ActiveView.PODCAST_LOADING;
};

export default useIsPodcastGenerating;
